import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import FeedbackModalWrapper from './components/FeedbackModalWrapper';

import { setShow } from './ducks';
import { addToast } from '~features/toast/ducks';

const ExternalFeedbackModal = () => {
  const dispatch = useDispatch();
  const npsUrl = useSelector(state => state.modals.npsUrl);
  const show = useSelector(state => state.modals.show === 'EXTERNAL_FEEDBACK');

  useEffect(() => {
    const handleMessage = event => {
      // If the modal isn't visible, don't handle any messages
      if (!show) return;

      // Only accept messages from the NPS iframe
      if (!__DEVELOPMENT__) {
        if (!npsUrl) return;

        const url = new URL(npsUrl);
        if (event.origin !== url?.origin) {
          return;
        }
      }

      switch (event.data) {
        case '3e-Asiakaspalaute-Close': {
          dispatch(setShow(''));
          break;
        }
        case '3e-Asiakaspalaute-Loaded': {
          break;
        }
        case '3e-Asiakaspalaute-Submitted': {
          dispatch(
            addToast({ message: 'Palaute lähetetty!', type: 'SUCCESS' })
          );
          dispatch(setShow(''));
          break;
        }
        case '3e-Asiakaspalaute-Completed': {
          dispatch(
            addToast({ message: 'Asiakaspalaute on jo annettu', type: 'INFO' })
          );
          dispatch(setShow(''));
          break;
        }
        case '3e-Asiakaspalaute-NotFound': {
          dispatch(
            addToast({ message: 'Asiakaspalautetta ei löydy', type: 'ERROR' })
          );
          dispatch(setShow(''));
          break;
        }
        case '3e-Asiakaspalaute-Error': {
          dispatch(
            addToast({ message: 'Virhe palautteenannossa', type: 'ERROR' })
          );
          dispatch(setShow(''));
          break;
        }
        default:
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [npsUrl]);

  return (
    <FeedbackModalWrapper name="EXTERNAL_FEEDBACK" noButtons>
      {npsUrl && (
        <iframe
          id="npsframe"
          title="nps iframe"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          src={__DEVELOPMENT__ ? '/npsTestbed.html' : npsUrl}
        />
      )}
    </FeedbackModalWrapper>
  );
};

export default ExternalFeedbackModal;
